// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--3KOUM","events":"hero-module--events--2y8xt"};